import { render, staticRenderFns } from "./SettingsStageRequiresAttachment.vue?vue&type=template&id=49b76722&"
import script from "./SettingsStageRequiresAttachment.vue?vue&type=script&lang=js&"
export * from "./SettingsStageRequiresAttachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports